import { NavLink } from "react-router-dom";

const Faq = () => {

    return (
      <>
        <article className="flex w-0 flex-1 flex-col gap-6 py-10">
          <div className="prose">
            <h1>Вопрос - ответ</h1>
            <h2 className="scroll-m-20" id="search">
                <a href="#search" className="not-prose group">Как я могу быстро найти нужную запчасть?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Наш интеллектуальный поиск позволяет найти деталь за считанные секунды. 
                Просто введите VIN-код или характеристики детали, и система покажет подходящие варианты.    
            </p>
            <h2 className="scroll-m-20" id="multisearch">
                <a href="#multisearch" className="not-prose group">Можно ли искать сразу несколько запчастей?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Да, благодаря нашей новой технологии вы можете искать и считать стоимость сразу нескольких запчастей одновременно, экономя ваше время. 
                Просто скопируйте и вставьте столбец из таблицы или введите через запятую искомые запчасти.
            </p>
            <h2 className="scroll-m-20" id="auto">
                <a href="#auto" className="not-prose group">Какие автомобили поддерживаются?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Наш каталог включает запчасти для большинства марок и моделей автомобилей, 
                включая популярные и редкие бренды, а также китайские бренды.        
            </p>
            <h2 className="scroll-m-20" id="logistics">
                <a href="#logistics" className="not-prose group">Как узнать, когда моя деталь будет доставлена?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                В личном кабинете доступна информация о статусе заказа и прогнозируемой дате доставки. 
                Вы также будете получать уведомления об изменениях.
            </p>
            <h2 className="scroll-m-20" id="payment">
                <a href="#payment" className="not-prose group">Как оплатить заказ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Мы предлагаем несколько вариантов оплаты: банковской картой онлайн, 
                через электронные кошельки или при получении товара.
            </p>
            <h2 className="scroll-m-20" id="support">
                <a href="#support" className="not-prose group">Что делать, если я не нашел нужную деталь?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Свяжитесь с нашей поддержкой через чат или оставьте запрос — мы поможем найти нужную запчасть или предложим альтернативные варианты.      
            </p>
            <h2 className="scroll-m-20" id="reviews">
                <a href="#reviews" className="not-prose group">Есть ли гарантия на запчасти?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Все запчасти поставляются от проверенных производителей и сопровождаются гарантией качества.   
            </p>
            <h2 className="scroll-m-20" id="changeadress">
                <a href="#changeadress" className="not-prose group">Можно ли изменить адрес доставки?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Да, в личном кабинете вы можете обновить адрес или время доставки до момента её отправки.     
            </p>
            <h2 className="scroll-m-20" id="filter">
                <a href="#filter" className="not-prose group">Как работают фильтры на сайте?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Наши фильтры позволяют сузить поиск по брендам, характеристикам, цене и другим параметрам, чтобы вы быстро нашли то, что нужно.   
            </p>
            <h2 className="scroll-m-20" id="return">
                <a href="#return" className="not-prose group">Что делать, если товар мне не подошел?
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Мы предлагаем простую систему возврата. Ознакомьтесь с условиями возврата в разделе «Политика возврата» или свяжитесь с нашей поддержкой.
            </p>
          </div>
          <div className="mt-4 flex flex-row flex-wrap gap-4 border-t py-12">
            <NavLink className="flex flex-row items-center gap-2 text-muted-foreground transition-colors hover:text-foreground ms-auto" to="/plan">
              <p className="text-end font-medium text-foreground">
                План
              </p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-right size-5 shrink-0 rtl:rotate-180">
                <path d="m9 18 6-6-6-6">
                </path>
              </svg>
            </NavLink>
          </div>
        </article>
      </>
    );
  };
  
  export default Faq;